/* @ngInject */
export default class RelationModulesService {
  constructor ($http, URLS) {
    this.$http = $http
    this.URLS = URLS
  }

  /**
   * Get relation module state
   * @param {string} moduleType - Module type (e.g., 'beeldzorg')
   * @param {number} relationId - Dashboard relation ID
   */
  getRelationModule (moduleType, relationId) {
    const url = `${this.URLS.admin.relationModules}/${moduleType}?relationId=${relationId}`
    return this.$http.get(url)
  }

  /**
   * Enable relation module
   * @param {string} moduleType - Module type (e.g., 'beeldzorg')
   * @param {number} relationId - Dashboard relation ID
   */
  enableRelationModule (moduleType, relationId) {
    const url = `${this.URLS.admin.relationModules}/${moduleType}/enable`
    return this.$http.post(url, { relationId })
  }

  /**
   * Disable relation module
   * @param {string} moduleType - Module type (e.g., 'beeldzorg')
   * @param {number} relationId - Dashboard relation ID
   */
  disableRelationModule (moduleType, relationId) {
    const url = `${this.URLS.admin.relationModules}/${moduleType}/disable`
    return this.$http.post(url, { relationId })
  }
}
